import { SignInPrompt } from './SignInPrompt.tsx';
import { useSignIn } from './use-sign-in.ts';

const currentLocation = (): string => `${window.location.pathname}${window.location.search}`;

export const SessionExpiredPage = () => {
  const signIn = useSignIn(currentLocation);
  return (
    <SignInPrompt
      stage="session"
      titleKey="shell.sessionExpiredTitle"
      descriptionKey="shell.sessionExpiredDescription"
      signIn={signIn}
    />
  );
};
